import { TRule } from '../../typings';

export const PNEUMATIK_PRICELIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: "c['EANCode']",
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: "c['ManufacturerArtNo']",
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.map',
    sourceKey: "c['Manufacturer']",
    destination: 'product',
    targetKey: 'brand',
  },
  {
    type: 'rule.map',
    sourceKey: "c['Cijena4']",
    destination: 'product',
    targetKey: 'priceEUR',
    outputType: 'number',
  },
];
